import React, { useEffect, useState } from "react";
import SpaceBetween from "@cloudscape-design/components/space-between";
import { SubmissionComponent } from "./SubmissionForm";
import { Modal } from "@cloudscape-design/components";
import { uploadFile } from "./docs";
import { useNavigate } from "react-router-dom";
import { startThreatModeling, generateUrl } from "../../services/ThreatDesigner/stats";
import GenAiButton from "../../components/ThreatModeling/GenAiButton";
import "./ThreatModeling.css";

export default function ThreatModeling() {
  const [iteration, setIteration] = useState({ label: "Auto", value: 0 });
  const [reasoning, setReasoning] = useState("0");
  const [base64Content, setBase64Content] = useState([]);
  const [id, setId] = useState(null);
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleBase64Change = (base64) => {
    setBase64Content(base64);
  };

  const handleStartThreatModeling = async (title, description, assumptions, approvedTools, smePdf = null) => {
    setLoading(true);
    try {
      // Handle multiple architecture diagrams
      const s3Locations = [];
      const filesArray = Array.isArray(base64Content) ? base64Content : [base64Content];
      
      for (let i = 0; i < filesArray.length; i++) {
        const file = filesArray[i];
        
        if (file && file.value) {
          const results = await generateUrl(file.type);
          
          await uploadFile(file.value, results?.data?.presigned, file.type);
          s3Locations.push(results?.data?.name);
        }
      }
      
      if (s3Locations.length === 0) {
        alert("No files were uploaded. Please select at least one architecture diagram.");
        setLoading(false);
        return;
      }
      
      // Upload SME PDF if provided
      let smePdfS3Path = null;
      if (smePdf) {
        console.log("🔍 SME PDF provided:", smePdf);
        const smePdfResults = await generateUrl(smePdf.type);
        console.log("🔍 SME PDF presigned URL generated:", smePdfResults?.data?.name);
        await uploadFile(smePdf.value, smePdfResults?.data?.presigned, smePdf.type);
        smePdfS3Path = smePdfResults?.data?.name;  // S3 key for SME PDF
        console.log("✅ SME PDF uploaded to S3:", smePdfS3Path);
      } else {
        console.log("⚠️ No SME PDF provided");
      }
      
      const response = await startThreatModeling(
        s3Locations,  // Array of S3 paths
        iteration?.value,
        reasoning,
        title,
        description,
        assumptions,
        approvedTools,
        false,  // replay
        null,   // id
        null,   // instructions
        smePdfS3Path  // NEW: SME PDF S3 path
      );
      console.log("🔍 API response:", response);
      setLoading(false);
      
      // Check if response is valid
      if (!response || !response.data || !response.data.id) {
        console.error("Invalid response from API:", response);
        alert("Failed to start threat modeling. Please check the console for details.");
        return;
      }
      
      setId(response.data.id);
    } catch (error) {
      console.error("Error starting threat modeling:", error);
      alert(`Error: ${error.message || 'Failed to start threat modeling'}`);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      navigate(`/${id}`);
    }
  }, [id]);

  return (
    <SpaceBetween size="s">
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ marginTop: "200px" }}>
          <GenAiButton
            onClick={() => {
              setVisible(true);
            }}
          >
            Submit Threat Model
          </GenAiButton>
        </div>
      </div>
      <Modal
        onDismiss={() => setVisible(false)}
        visible={visible}
        size="large"
        header={"Threat model"}
      >
        <SubmissionComponent
          onBase64Change={handleBase64Change}
          base64Content={base64Content}
          iteration={iteration}
          setIteration={setIteration}
          setVisible={setVisible}
          handleStart={handleStartThreatModeling}
          loading={loading}
          reasoning={reasoning}
          setReasoning={setReasoning}
        />
      </Modal>
    </SpaceBetween>
  );
}
